import type { ColDef } from 'ag-grid-community';
import type React from 'react';

import { textRenderer } from '@/utils/GridRenderer.utils';

import {
  ActiveStateCellRenderer,
  NameCellRenderer,
  StatusCellRenderer
} from './CloudSourcesTable.cellRenderers';
import type { CloudSourceTreeNode } from './CloudSourcesTable.types';

export const autoGroupColumnDef: ColDef<CloudSourceTreeNode> = {
  headerName: 'Source',
  field: 'name',
  minWidth: 250,
  maxWidth: 350,
  width: 350,
  cellClass: 'ellipsis-cell',
  cellRenderer: 'agGroupCellRenderer',
  suppressHeaderMenuButton: true,
  cellRendererParams: {
    suppressCount: true,
    suppressDoubleClickExpand: false,
    suppressEnterExpand: false,
    innerRenderer: NameCellRenderer,
    suppressExpandIcon: (params: { data?: CloudSourceTreeNode }) => {
      const node = params.data;
      return !(node?.hasChildren === true);
    }
  }
};

export const LIMA_CLOUD_SOURCES_COLUMN_DEFS: ColDef<CloudSourceTreeNode>[] = [
  {
    field: 'organization',
    headerName: 'Organization',
    minWidth: 120,
    flex: 1,
    width: 120,
    sortable: true,
    filter: false,
    resizable: true,
    suppressHeaderMenuButton: true
  },
  {
    field: 'ingestMethod',
    cellRenderer: textRenderer,
    headerName: 'Ingest Method',
    headerTooltip: 'Ingest Method',
    sortable: true,
    width: 120,
    suppressHeaderMenuButton: true
  },
  {
    field: 'status',
    cellRenderer: StatusCellRenderer as React.ComponentType<unknown>,
    headerName: 'Status',
    headerTooltip: 'Status',
    sortable: true,
    width: 120,
    suppressHeaderMenuButton: true
  },
  {
    field: 'lastSeen',
    cellRenderer: textRenderer,
    headerName: 'Last Seen',
    headerTooltip: 'Last Seen',
    sortable: true,
    width: 120,
    suppressHeaderMenuButton: true
  },
  {
    field: 'deviceName',
    cellRenderer: textRenderer,
    headerName: 'Device Name',
    headerTooltip: 'Device Name',
    sortable: true,
    width: 120,
    minWidth: 120,
    flex: 1,
    suppressHeaderMenuButton: true
  },
  {
    field: 'active',
    cellRenderer: ActiveStateCellRenderer as React.ComponentType<unknown>,
    headerName: 'Active',
    headerTooltip: 'Active',
    sortable: true,
    width: 120,
    suppressHeaderMenuButton: true
  }
];
